import React from 'react';
import { ChevronRight, ArrowRight } from 'lucide-react';

const SolutionsSection = () => {
  const solutions = [
    {
      id: 'family',
      title: 'Family & Individual Solutions',
      description:
        'Thoughtful insurance solutions designed to help individuals and families plan for education, income, retirement, and long-term financial security.',
      image: process.env.PUBLIC_URL + '/images/service-life.jpeg',
      bullets: [
        'Family Secure Plan',
        'Children Education / KG–PG Scheme',
        'Pension & Income Solutions',
      ],
    },
    {
      id: 'msme',
      title: 'MSME & Corporate Insurance',
      description:
        'Risk-management solutions designed to support business continuity, protect key interests, and strengthen the long-term sustainability of your business.',
      image: process.env.PUBLIC_URL + '/images/service-msme.jpg',
      bullets: [
        'Partnership Insurance',
        'Key Man Insurance',
        'Group Insurance',
        'Employer–Employee Insurance',
      ],
    },
    {
      id: 'support',
      title: 'Policy Servicing & Support',
      description:
        'Ongoing support for policy updates, documentation, premium-related needs, claims, nominations, and other policy service requirements.',
      image: process.env.PUBLIC_URL + '/images/service-policy.jpg',
      bullets: [
        'Policy Updates',
        'Nomination & Beneficiary Changes',
        'Premium & Policy Support',
        'Claim Assistance',
      ],
    },
  ];

  return (
    <section className="solutions-section-container" id="solutions">
      <div className="solutions-content-wrapper">
        
        {/* Section Title */}
        <h2 className="solutions-main-title">
          INSURANCE &amp; RISK MANAGEMENT SOLUTIONS
        </h2>

        {/* 3 Column Cards Grid */}
        <div className="solutions-cards-grid">
          {solutions.map((item) => (
            <div key={item.id} className="solution-card">
              
              {/* Card Image */}
              <div className="solution-img-box">
                <img src={item.image} alt={item.title} className="solution-img" />
              </div>

              {/* Title & Description */}
              <h3 className="solution-card-title">{item.title}</h3>
              <p className="solution-card-desc">{item.description}</p>

              {/* Bottom Section: Bullet Points & Arrow Action Icon */}
              <div className="solution-card-bottom">
                <ul className="solution-bullets-list">
                  {item.bullets.map((bullet, index) => (
                    <li key={index} className="bullet-item">
                      <ChevronRight size={16} className="bullet-chevron" />
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>

                <div className="solution-card-arrow">
                  <ArrowRight size={20} />
                </div>
              </div>

            </div>
          ))}
        </div>

        {/* Bottom CTA Button */}
        <div className="solutions-cta-box">
          <a href="#solutions" className="btn-view-all-insurances">
            <span>Explore All Solutions</span>
            <ArrowRight size={18} className="btn-arrow" />
          </a>
        </div>

      </div>
    </section>
  );
};

export default SolutionsSection;
